module.exports = __webpack_public_path__ + "rfm-avatar-big-spender-at-risk.svg?3dd067759e7cd7f5dfe002d69df0094c";